import KendaraanSelectorDialog from "../../../../dialogs/selectors/KendaraanSelectorDialog";
import KaryawanSelectorDialog from "../../../../dialogs/selectors/KaryawanSelectorDialog";
import TujuanSelectorDialog from "../../../../dialogs/selectors/TujuanSelectorDialog";
import PengecekanMobilOptionSelectorDialog from "../../../../dialogs/selectors/PengecekanMobilOptionSelectorDialog";

// TrailerDialogs: the variant's trailer selector dialog(s)
// kendaraanFilter: which vehicles the vehicle selector may show
const EditorSelectorDialogs = ({
  TrailerDialogs,
  kendaraanFilter,
  headerData,
  showPengecekanMobilOptionDialog,
  setShowPengecekanMobilOptionDialog,
  handleOnConfirmPengecekanMobilOption,
  optionSelectorAdditionalFilter,
  pengecekanMobilOptionDialogData,
  showKendaraanSelector,
  setShowKendaraanSelector,
  handleOnConfirmKendaraan,
  showSupirSelector,
  setShowSupirSelector,
  handleOnConfirmSupir,
  showSupirPulangSelector,
  setShowSupirPulangSelector,
  handleOnConfirmSupirPulang,
  showPemakaiSelector,
  setShowPemakaiSelector,
  handleOnConfirmPemakai,
  showTujuanSelector,
  setShowTujuanSelector,
  handleOnConfirmTujuan,
  ...trailerProps
}) => {
  return (
    <>
      <PengecekanMobilOptionSelectorDialog
        title="Pilih Keterangan Marking"
        visible={showPengecekanMobilOptionDialog}
        onHide={() => setShowPengecekanMobilOptionDialog(false)}
        onConfirm={handleOnConfirmPengecekanMobilOption}
        additionalFilter={optionSelectorAdditionalFilter}
        kendaraanJenisId={
          headerData.data_kendaraan &&
          headerData.data_kendaraan.kendaraan_jenis_id
            ? headerData.data_kendaraan.kendaraan_jenis_id
            : 0
        }
        labelGrup={
          pengecekanMobilOptionDialogData.label_grup
            ? pengecekanMobilOptionDialogData.label_grup
            : ""
        }
      />
      <KendaraanSelectorDialog
        title="Pilih Kendaraan"
        additionalFilter={kendaraanFilter}
        visible={showKendaraanSelector}
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />
      <TrailerDialogs {...trailerProps} />
      <KaryawanSelectorDialog
        title="Pilih Supir Berangkat"
        visible={showSupirSelector}
        onHide={() => setShowSupirSelector(false)}
        onConfirm={handleOnConfirmSupir}
        additionalFilter={"jabatan_id:in:2,7,8"}
      />
      <KaryawanSelectorDialog
        title="Pilih Supir Pulang"
        visible={showSupirPulangSelector}
        onHide={() => setShowSupirPulangSelector(false)}
        onConfirm={handleOnConfirmSupirPulang}
        additionalFilter={"jabatan_id:in:2,7,8"}
      />
      <KaryawanSelectorDialog
        title="Pilih Pemakai"
        visible={showPemakaiSelector}
        onHide={() => setShowPemakaiSelector(false)}
        onConfirm={handleOnConfirmPemakai}
      />
      <TujuanSelectorDialog
        title="Pilih Tujuan"
        visible={showTujuanSelector}
        onHide={() => setShowTujuanSelector(false)}
        onConfirm={handleOnConfirmTujuan}
      />
    </>
  );
};

export default EditorSelectorDialogs;
